import React, { useEffect, useState } from "react";
import SheetSkeleton from "../sheet/sheetSkeleton";

import { Modal, notification } from "antd";
import OtpInput from "../input/otpInput";
import CheckUserPin from "../../functions/user/checkUserPin";
import CheckUserHasPin from "../../functions/user/checkUserHasPin";
import SetUserPin from "./setUserPin";
import Loader from "../other/loader";

const AskUserPin = ({ open, close, userId, verified }) => {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(true);
  const [userHasPin, setUserHasPin] = useState(null);
  useEffect(() => {
    if (userId) {
      checkUserHasPin();
    }
  }, [userId]);
  const checkUserHasPin = async () => {
    const result = await CheckUserHasPin(userId);
    setLoading(false);
    if (result && result.data) {
      setUserHasPin(true);
    } else {
      setUserHasPin(false);
    }
  };
  const changePin = async (e) => {
    setPin(e);
    if (e && e.length === 4) {
      setLoading(true);
      const result = await CheckUserPin(userId, e);
      //console.log(result);
      setLoading(false);
      if (result && result.success) {
        return success(e);
      }
      if (result.locked) return failed(result.message);
      if (!result.success)
        return notification.error({ message: result.message });
    }
  };
  const success = (e) => {
    verified(e);
    setLoading(false);
    close();
    return;
  };
  const failed = (message) => {
    notification.error({ message: message });
    setLoading(false);
    close();
    return;
  };
  const pinSetted = () => checkUserHasPin();
  if (loading) return <Loader />;
  if (userHasPin === false) {
    return (
      <SetUserPin
        open={open}
        close={close}
        userId={userId}
        pinSetted={pinSetted}
      />
    );
  } else
    return (
      <Modal open={open} footer={null} size={250} onCancel={close}>
        <div className="flex flex-col bg-gray-200 w-[94%] p-4 justify-start items-start gap-4">
          <div className="askPinTitle">
            <span>Ta гүйлгээний пин кодоо оруулна уу</span>
          </div>
          <OtpInput value={pin} onChange={changePin} />
          <div className="cancelPinContainer" onClick={close}>
            <span>Цуцлах</span>
          </div>
        </div>
      </Modal>
    );
};

export default AskUserPin;
